import { CKEditor } from '@ckeditor/ckeditor5-react';
import {
  ClassicEditor,
  Essentials,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Underline,
  Strikethrough,
  Link,
  List,
  BlockQuote,
  CodeBlock,
  HorizontalLine,
  Undo,
  Font,
  Alignment,
  Highlight,
  RemoveFormat,
} from 'ckeditor5';

import 'ckeditor5/ckeditor5.css';

interface RichTextEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export default function RichTextEditor({
  value,
  onChange,
  disabled = false,
}: RichTextEditorProps) {
  return (
    <CKEditor
      editor={ClassicEditor}
      disabled={disabled}
      data={value || ''}
      config={{
        licenseKey: 'GPL',

        plugins: [
          Essentials,
          Paragraph,
          Heading,
          Bold,
          Italic,
          Underline,
          Strikethrough,
          Link,
          List,
          BlockQuote,
          CodeBlock,
          HorizontalLine,
          Undo,
          Font,
          Alignment,
          Highlight,
          RemoveFormat,
        ],

        toolbar: {
          items: [
            'undo',
            'redo',
            '|',
            'heading',
            '|',
            'bold',
            'italic',
            'underline',
            'strikethrough',
            '|',
            'fontSize',
            'fontFamily',
            'fontColor',
            'fontBackgroundColor',
            '|',
            'alignment',
            '|',
            'bulletedList',
            'numberedList',
            '|',
            'link',
            'blockQuote',
            'codeBlock',
            'horizontalLine',
            '|',
            'removeFormat',
          ],
          shouldNotGroupWhenFull: true,
        },

        heading: {
          options: [
            {
              model: 'paragraph',
              title: 'Paragraph',
              class: 'ck-heading_paragraph',
            },
            {
              model: 'heading1',
              view: 'h1',
              title: 'Heading 1',
              class: 'ck-heading_heading1',
            },
            {
              model: 'heading2',
              view: 'h2',
              title: 'Heading 2',
              class: 'ck-heading_heading2',
            },
            {
              model: 'heading3',
              view: 'h3',
              title: 'Heading 3',
              class: 'ck-heading_heading3',
            },
            {
              model: 'heading4',
              view: 'h4',
              title: 'Heading 4',
              class: 'ck-heading_heading4',
            },
          ],
        },

        link: {
          addTargetToExternalLinks: true,
          defaultProtocol: 'https://',
        },

        fontSize: {
          options: [
            10,
            12,
            14,
            'default',
            18,
            20,
            24,
            28,
            32,
          ],
        },

        fontFamily: {
          options: [
            'default',
            'Arial',
            'Georgia',
            'Times New Roman',
            'Verdana',
          ],
        },

        alignment: {
          options: ['left', 'center', 'right', 'justify'],
        },

        placeholder: 'Write your blog content...',
      }}
      onChange={(_, editor) => {
        const data = editor.getData();
        onChange(data);
      }}
    />
  );
}
